(() => {
  const initializeIngredients = (section) => {
    if (section.dataset.iamaranthIngredientsReady === 'true') return;
    section.dataset.iamaranthIngredientsReady = 'true';
    const dialog = section.querySelector('[data-ingredient-dialog]');
    if (!dialog) return;
    section.querySelectorAll('[data-ingredient-open]').forEach((button) => button.addEventListener('click', () => {
      const template = section.querySelector(`[data-ingredient-template="${button.dataset.ingredientOpen}"]`);
      if (!template) return;
      dialog.innerHTML = template.innerHTML;
      dialog.showModal();
      dialog.querySelector('[data-ingredient-close]')?.focus();
    }));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-ingredient-close]')) dialog.close();
    });
  };
  const initializeFaqs = (section) => {
    if (section.dataset.iamaranthFaqReady === 'true') return;
    section.dataset.iamaranthFaqReady = 'true';
    const buttons = section.querySelectorAll('[data-faq-filter]');
    const items = section.querySelectorAll('[data-faq-item]');
    const empty = section.querySelector('[data-faq-empty]');
    const setFilter = (key) => {
      let count = 0;
      items.forEach((item) => {
        const visible = key === 'todas' || item.dataset.faqCategory === key;
        item.hidden = !visible;
        if (visible) count += 1;
      });
      if (empty) empty.hidden = count !== 0;
      buttons.forEach((button) => {
        const selected = button.dataset.faqFilter === key;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    };
    buttons.forEach((button) => button.addEventListener('click', () => setFilter(button.dataset.faqFilter)));
    setFilter(section.querySelector('.is-active')?.dataset.faqFilter || 'todas');
  };
  const initializeAll = () => {
    document.querySelectorAll('[data-iamaranth-ingredients-page]').forEach(initializeIngredients);
    document.querySelectorAll('[data-iamaranth-faq-page]').forEach(initializeFaqs);
  };
  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
})();
